import AppIcon from '../icons/AppIcon'
import PipRow from '../primitives/PipRow'
import styles from './RestDayPill.module.css'

interface RestDayPillProps {
  remaining: number
  total: number
  used: number
}

export default function RestDayPill({ remaining, total, used }: RestDayPillProps) {
  return (
    <div className={styles.pill} data-testid="rest-day-pill">
      <AppIcon icon="mdi:moon-waning-crescent" size={22} className={styles.icon} />
      <span className={styles.text}>
        <b>
          {remaining} rest day{remaining === 1 ? '' : 's'}
        </b>{' '}
        left this challenge
      </span>
      <PipRow total={total} used={used} />
    </div>
  )
}
